import React, {createContext, ReactNode, useState} from 'react';

type RecordsModalContextValue = {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
};

export const RecordsModalContext = createContext<RecordsModalContextValue>({
  isModalOpen: false,
  setIsModalOpen: () => {},
});

type RecordsModalContextProviderProps = {
  children: ReactNode;
};

export function RecordsModalContextProvider({
  children,
}: RecordsModalContextProviderProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <RecordsModalContext.Provider value={{isModalOpen, setIsModalOpen}}>
      {children}
    </RecordsModalContext.Provider>
  );
}
